<template>
    <div class="" style="padding: 0;height: 100%;width: 90%;">
        <div class="" id="homeBottom" @mouseenter="clearDispatchTimer" @mouseleave="setDispatchTimer"
            style="height: 100%;width: 100%;"></div>
    </div>
</template>

<script>
import * as echarts from 'echarts'
import 'echarts-gl'
export default {
    data() {
        return {
            interVal: '',
            myChart: null,
            app: {
                currentIndex: -1,
            },
            dispatchTimer: null,
            dataLen: null
        }
    },
    mounted() {
        // this.requestData(500)
        this.init()
    },
    methods: {
        requestData(number, area, tulongNum, beforeMoney, afterMoney) {
            this.$request('center/newService1/farmLines?num=' + number + '&area=' + area + '&tulongNum=' + tulongNum + '&beforeMoney=' + beforeMoney + '&afterMoney=' + afterMoney).then(res => {
                if (this.myChart) {
                    clearInterval(this.dispatchTimer)
                    this.myChart.clear()
                }
                for (var i = 0; i < res.data.length; i++) {
                    if (res.data[i].type == 1) {
                        this.init(res.data[i].list);
                    }
                }

            })
        },
        init(pageData, type) {
            let that = this
            that.myChart = echarts.init(document.getElementById('homeBottom'))

            //随着屏幕大小调节图表
            window.addEventListener("resize", () => {
                that.myChart.resize();
            });

            var dataList = [
                { name: '地块854亩', value: '28' },
                { name: '地块912亩', value: '32' },
                { name: '地块810亩', value: '19' },
                { name: '地块848亩', value: '31' },
            ];
            var color = ['#14FCFE', '#F79422', '#0092FE', '#FF5B5B']
            var option = {
                color: color,
                tooltip: {
                    show: true,
                    backgroundColor: '#001127',
                    textStyle: {
                        color: '#fff'
                    },
                    formatter: function (params) {
                        return `${params.name}  浇水${params.value}万m³`
                    }
                },
                legend: [
                    {
                        show: false,
                    },
                ],
                series: [
                    {
                        type: 'pie',
                        radius: ['35%', '55%'],
                        label: {
                            formatter: function (params) {
                                return '{a|' + params.name + '}\n\n\n{b| 浇水' + params.value + '万m³}';
                            },
                            alignTo: 'labelLine',
                            rich: {
                                a: {
                                    color: '#fff',
                                    fontSize: '13px',
                                },
                                b: {
                                    color: '#fff',
                                    fontSize: '13px',
                                },
                            },
                        },
                        labelLine: {
                            show: true, // 是否显示视觉引导线
                            normal: {
                                length: 30, // 视觉引导线第一段的长度
                                length2: 50, // 视觉引导线第一段的长度
                                align: 'right',
                                lineStyle: {
                                    width: 1 // 线宽
                                }
                            }
                        },
                        itemStyle: {
                            borderWidth: 2, // 描边线宽
                            borderColor: '#001127' // 图形的描边颜色
                        },
                        data: dataList
                    }
                ]
            };


            that.dataLen = option.series[0].data.length
            that.dispatchActions()

            that.myChart.setOption(option);
            this.interVal = setInterval(function () {
                that.myChart.clear()
                that.myChart.setOption(option);
            }, 240000)
            // 20000
        },
        dispatchActions() {
            let that = this
            that.dispatchTimer = setInterval(function () {
                // 取消之前高亮的图形
                that.myChart.dispatchAction({
                    type: 'downplay',
                    seriesIndex: 0,
                    dataIndex: that.app.currentIndex
                });
                that.app.currentIndex = (that.app.currentIndex + 1) % that.dataLen;
                //console.log(app.currentIndex);
                // 高亮当前图形
                that.myChart.dispatchAction({
                    type: 'highlight',
                    seriesIndex: 0,
                    dataIndex: that.app.currentIndex,
                });
                // 显示 tooltip
                that.myChart.dispatchAction({
                    type: 'showTip',
                    seriesIndex: 0,
                    dataIndex: that.app.currentIndex
                });
            }, 3000);
        },
        clearDispatchTimer() {
            clearInterval(this.dispatchTimer)
        },
        setDispatchTimer() {
            this.dispatchActions()
        },
    },
    destroyed() {
        clearInterval(this.interVal)
    },

}
</script>

<style>
.a {
    /* color: #fff; */
}

#homeBottom {
    background-image: url('https://ica.obs.cn-south-1.myhuaweicloud.com/screen/gif/%E6%97%8B%E8%BD%AC%E7%8E%AF.png');
    background-size: 155px;
    height: 155px;
    background-repeat: no-repeat;
    background-position-x: 120px;
    background-position-y: 22px;
}
</style>